import { IdsInput } from '../../lib/types/utils'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function deleteHostFamilies(ids: number[]) {
  return restApiClient
    .url(encodeNestedObject<IdsInput>(constructApiUrl(API.hostFamilies.delete.url, null), { ids }))
    .delete()
}
